/**
 * @generated SignedSource<<b49908f9ad04af77577446ac0260749f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillsAllSkillsQuery$variables = {
  after?: string | null | undefined;
  ancestriesIds?: ReadonlyArray<string> | null | undefined;
  before?: string | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  searchQuery: string;
  skip?: boolean | null | undefined;
};
export type SkillsAllSkillsQuery$data = {
  readonly searchSkills?: {
    readonly nodes: ReadonlyArray<{
      readonly assessmentInfo: string | null | undefined;
      readonly code: string | null | undefined;
      readonly id: string;
      readonly lessons: ReadonlyArray<{
        readonly id: string;
      } | null | undefined> | null | undefined;
      readonly name: string | null | undefined;
      readonly skillAncestries: ReadonlyArray<{
        readonly ancestorSkill: {
          readonly code: string | null | undefined;
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly skillRelevance: {
          readonly id: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly standards: ReadonlyArray<{
        readonly id: string;
        readonly longName: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly summary: string | null | undefined;
    }> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
    readonly totalCount: number;
  } | null | undefined;
};
export type SkillsAllSkillsQuery = {
  response: SkillsAllSkillsQuery$data;
  variables: SkillsAllSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ancestriesIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skip"
},
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "searchQuery",
    "variableName": "searchQuery"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assessmentInfo",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "StandardNode",
  "kind": "LinkedField",
  "name": "standards",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "longName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "skillRelevanceIds",
        "variableName": "ancestriesIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v15 = [
  (v8/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillRelevanceNode",
  "kind": "LinkedField",
  "name": "skillRelevance",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillNode",
  "kind": "LinkedField",
  "name": "ancestorSkill",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "isActive": true,
        "lessonTypeIds": [
          "LessonTypeNode:11"
        ]
      }
    }
  ],
  "concreteType": "LessonSkillNode",
  "kind": "LinkedField",
  "name": "lessons",
  "plural": true,
  "selections": (v15/*: any*/),
  "storageKey": "lessons(filter:{\"isActive\":true,\"lessonTypeIds\":[\"LessonTypeNode:11\"]})"
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SkillsAllSkillsQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "SkillNodeConnection",
            "kind": "LinkedField",
            "name": "searchSkills",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillNode",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": (v14/*: any*/),
                    "concreteType": "SkillAncestryNode",
                    "kind": "LinkedField",
                    "name": "skillAncestries",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v19/*: any*/),
              (v20/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SkillsAllSkillsQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "SkillNodeConnection",
            "kind": "LinkedField",
            "name": "searchSkills",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillNode",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": (v14/*: any*/),
                    "concreteType": "SkillAncestryNode",
                    "kind": "LinkedField",
                    "name": "skillAncestries",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v19/*: any*/),
              (v20/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "04d3af4be4cb20662769c50073d29573",
    "id": null,
    "metadata": {},
    "name": "SkillsAllSkillsQuery",
    "operationKind": "query",
    "text": "query SkillsAllSkillsQuery(\n  $first: Int\n  $after: String\n  $last: Int\n  $before: String\n  $searchQuery: String!\n  $skip: Boolean = false\n  $ancestriesIds: [ID!]\n) {\n  searchSkills(searchQuery: $searchQuery, first: $first, after: $after, last: $last, before: $before) @skip(if: $skip) {\n    nodes {\n      id\n      name\n      assessmentInfo\n      summary\n      code\n      standards {\n        id\n        longName\n      }\n      skillAncestries(filter: {skillRelevanceIds: $ancestriesIds}) {\n        skillRelevance {\n          id\n        }\n        ancestorSkill {\n          id\n          name\n          code\n        }\n        id\n      }\n      lessons(filter: {lessonTypeIds: [\"LessonTypeNode:11\"], isActive: true}) {\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "e310549ea22036873445db1643caf9c2";

export default node;
